module.exports = "https://dashboard.cdn.gifty.nl/6338/images/emoti-4.png?cdaa7c5128ee9fbe5b40a286e39a6df6";